var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dashboard-action",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('i',{staticClass:"dashboard-action__icon",class:'el-icon-' + _vm.icon}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"dashboard-action__text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db833c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard-action.vue
// module id = 547
// module chunks = 0